(function () {
    'use strict';

    angular
        .module('app')
        .controller('B2bPartnersController', B2bPartnersController);

    B2bPartnersController.$inject = ['$state',];

    function B2bPartnersController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'b2bPartners') {
                $state.go('b2bPartners.list');
            }
        }
    }
})();